<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="cn" id="_idParaDest-4"><a id="_idTextAnchor003"></a>Contents</h1>
<p class="toc"><span href="#/GiveTheDevilHisDue#_idTextAnchor000" title="Link target outside of Sample">Front Cover</span></p>
<p class="toc"><a href="#/GiveTheDevilHisDue2#_idTextAnchor001">Title Page</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue3#_idTextAnchor002">Copyright</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue6#_idTextAnchor004">Chapter 1</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue7#_idTextAnchor005">Chapter 2</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue8#_idTextAnchor006">Chapter 3</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue9#_idTextAnchor007">Chapter 4</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue10#_idTextAnchor008">Chapter 5</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue11#_idTextAnchor009">Chapter 6</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue12#_idTextAnchor010">Chapter 7</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue13#_idTextAnchor011">Chapter 8</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue14#_idTextAnchor012">Chapter 9</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue15#_idTextAnchor013">Chapter 10</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue16#_idTextAnchor014">Chapter 11</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue17#_idTextAnchor015">Chapter 12</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue18#_idTextAnchor016">Chapter 13</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue19#_idTextAnchor017">Chapter 14</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue20#_idTextAnchor018">Chapter 15</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue21#_idTextAnchor019">Chapter 16</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue22#_idTextAnchor020">Chapter 17</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue23#_idTextAnchor021">Chapter 18</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue24#_idTextAnchor022">Chapter 19</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue25#_idTextAnchor023">Chapter 20</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue26#_idTextAnchor024">Chapter 21</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue27#_idTextAnchor025">Chapter 22</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue28#_idTextAnchor026">Chapter 23</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue29#_idTextAnchor027">Chapter 24</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue30#_idTextAnchor028">Chapter 25</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue31#_idTextAnchor029">Chapter 26</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue32#_idTextAnchor030">Chapter 27</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue33#_idTextAnchor031">Chapter 28</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue34#_idTextAnchor032">Chapter 29</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue35#_idTextAnchor033">Chapter 30</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue36#_idTextAnchor034">Chapter 31</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue37#_idTextAnchor035">Chapter 32</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue38#_idTextAnchor036">Chapter 33</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue39#_idTextAnchor037">Chapter 34</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue40#_idTextAnchor038">Chapter 35</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue41#_idTextAnchor039">Chapter 36</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue42#_idTextAnchor040">Chapter 37</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue43#_idTextAnchor041">Epilogue</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue44#_idTextAnchor042">Don’t miss <em class="i">A Murder Unmentioned</em>: Excerpt</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue45#_idTextAnchor043">Acknowledgments</a></p>
<p class="toc"><a href="#/GiveTheDevilHisDue46#_idTextAnchor044">About the Author</a></p>
<p class="toc _idGenParaOverride-1"><a href="#/GiveTheDevilHisDue47#_idTextAnchor045">Back Cover</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// GiveTheDevilHisDue-4.vue?4c0935e2